import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

import TipoOrdenCompraConstant from 'constants/tipoOrdenCompra'

const TipoDocumentoFormGroup = ({ fIsSubmitting, values }) => {
  return (
    <Row>
      <Col md={3}></Col>
      <Col md={4}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={values.tipo === TipoOrdenCompraConstant.ORDENCOMPRA}
              id='radio-tipo-ordencompra'
              label={
                TipoOrdenCompraConstant.__dictionary[TipoOrdenCompraConstant.ORDENCOMPRA]
                  .nombreCorto
              }
              value={TipoOrdenCompraConstant.__dictionary[TipoOrdenCompraConstant.ORDENCOMPRA].id}
            />
          )}
        </Field>
      </Col>
      <Col md={4}>
        <Field name='tipo'>
          {({ field }) => (
            <Form.Radio
              {...field}
              disabled={fIsSubmitting}
              checked={values.tipo === TipoOrdenCompraConstant.ORDENSERVICIO}
              id='radio-tipo-ordenservicio'
              label={
                TipoOrdenCompraConstant.__dictionary[TipoOrdenCompraConstant.ORDENSERVICIO]
                  .nombreCorto
              }
              value={TipoOrdenCompraConstant.__dictionary[TipoOrdenCompraConstant.ORDENSERVICIO].id}
            />
          )}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(TipoDocumentoFormGroup)
